import { render, staticRenderFns } from "./LoanStatusIcon.vue?vue&type=template&id=cdcd0524"
import script from "./LoanStatusIcon.vue?vue&type=script&lang=js"
export * from "./LoanStatusIcon.vue?vue&type=script&lang=js"
import style0 from "./LoanStatusIcon.vue?vue&type=style&index=0&id=cdcd0524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports